import { createContext, useEffect, useState } from "react";
import Loader from "../components/common/Loader";
import { GetUserNotificationList, NotificationCount, NotificationView } from "../services/Notification/NotificationApi";
import { format, parse } from "date-fns";
export const AuthContext = createContext();
export const LoaderContext = createContext();

const AuthProvider = ({ children }) => {
  const [authDetails, setAuthDetails] = useState(
    JSON.parse(localStorage.getItem("login"))
  );
  const [UserAccess, setUserAccess] = useState(
    JSON.parse(localStorage.getItem("UserAccess"))
  );
  //pagination size all module const
  const pageSize = 20;
  //module name
  const PanalModuleName = "Customer";
  const [NotificationListCount, setServicesListCount] = useState(-1);
  const [unSeenCount, setUnSeenCount] = useState(-1);
  const [notificationList, setNotificationList] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0)
  useEffect(() => {
    // Set initial auth details from localStorage
    const storedAuth = JSON.parse(localStorage.getItem("login"));
    const Access = JSON.parse(localStorage.getItem("UserAccess"));
    if (Access) {
      setUserAccess(Access);
      handleSetAccessData();
    }
    if (storedAuth) {
      setAuthDetails(storedAuth);
    }
  }, []);
  useEffect(() => {
    handleSetAccessData();
  }, [UserAccess]);






  //login set function
  const setLoginItem = (logInItem, roleTypePermissions) => {
    setAuthDetails(logInItem);
    setUserAccess(roleTypePermissions);
    localStorage.setItem("login", JSON.stringify(logInItem));
    localStorage.setItem("UserAccess", JSON?.stringify(roleTypePermissions));
  };

  //contact first, second Number name creation function.
  const ucFirst = (word) => word.charAt(0).toUpperCase() + word.slice(1); // Upper Case First Leter
  const stringifyNumber = (n) => {
    const special = [
      "zeroth",
      "first",
      "second",
      "third",
      "fourth",
      "fifth",
      "sixth",
      "seventh",
      "eighth",
      "ninth",
      "tenth",
      "eleventh",
      "twelfth",
      "thirteenth",
      "fourteenth",
      "fifteenth",
      "sixteenth",
      "seventeenth",
      "eighteenth",
      "nineteenth",
    ];
    const deca = [
      "twent",
      "thirt",
      "fort",
      "fift",
      "sixt",
      "sevent",
      "eight",
      "ninet",
    ];
    const bigs = [
      "",
      "thousand",
      "million",
      "billion",
      "trillion",
      "quadrillion",
      "quintillion",
    ]; // Add more as needed
    let numStr = "";

    const chunkify = (num) => {
      const chunks = [];
      while (num > 0) {
        chunks.push(num % 1000);
        num = Math.floor(num / 1000);
      }
      return chunks;
    };

    const chunkToWords = (chunk) => {
      if (chunk === 0) return "";
      let words = "";
      const hundreds = Math.floor(chunk / 100);
      const tens = chunk % 100;
      if (hundreds > 0) {
        words += special[hundreds] + " hundred";
        if (tens > 0) words += " and ";
      }
      if (tens < 20) {
        words += special[tens];
      } else {
        const tensIndex = Math.floor(tens / 10) - 2;
        words += deca[tensIndex];
        if (tens % 10 !== 0) words += "y-" + special[tens % 10];
      }
      return words;
    };

    const chunks = chunkify(n);
    const wordsArray = chunks.map((chunk, index) => {
      const bigName = bigs[index];
      const chunkWords = chunkToWords(chunk);
      return chunkWords + (chunkWords && bigName ? " " + bigName : "");
    });

    numStr = wordsArray.reverse().join(" ");

    return ucFirst(numStr);
  };
  const handlePhoneNumberInput = (value) => {
    // Remove non-numeric characters
    const cleanedValue = value.replace(/\D/g, "");

    // Limit to 10 digits
    return cleanedValue.slice(0, 10);
  };

  const validateEmail = (email) => {
    // Basic regex for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    return emailRegex.test(email);
  };
  const validateHours = (value, field) => {
    let errorMessage = "";

    if (value === "") {
      errorMessage = "This field is required";
    } else if (isNaN(value)) {
      errorMessage = "Only numbers are allowed";
    } else if (Number(value) < 0) {
      errorMessage = "Value cannot be negative";
    } else if (Number(value) > 24) {
      errorMessage = "Max 24 hours allowed"; // or whatever your limit is
    }

    return errorMessage;
  };

  // userAccess Functionality here
  const [defaultAccess, setDefaultAccess] = useState(null);

  const hasActionAccess = (moduleId, mActionId) => {
    let userAccess = localStorage.getItem("UserAccess");
    userAccess = JSON.parse(userAccess);
    if (userAccess == undefined || userAccess.length === 0) {
      return;
    }

    const action = userAccess?.find(
      (act) => act.mActionId === mActionId && act.moduleId === moduleId
    );
    if (action && action.setDefaultAction === true) {
      return true;
    }
    return false;
  };
  const hasReportDefaultAction = () => {
    let userAccess = localStorage.getItem("UserAccess");
    userAccess = JSON.parse(userAccess);

    if (!userAccess || userAccess.length === 0) {
      return false;
    }

    // filter only "Report" modules and check if any has setDefaultAction true
    return userAccess
      .filter(act => act.moduleName?.toLowerCase().includes("report"))
      .some(act => act.setDefaultAction === true);
  };
  const hasConfigDefaultAction = () => {
    let userAccess = localStorage.getItem("UserAccess");
    userAccess = JSON.parse(userAccess);

    if (!userAccess || userAccess.length === 0) {
      return false;
    }

    // filter only "Report" modules and check if any has setDefaultAction true
    return userAccess
      .filter(act => act.moduleName?.toLowerCase().includes("configure"))
      .some(act => act.setDefaultAction === true);
  };
  const handleSetAccessData = () => {
    setDefaultAccess({
      ...defaultAccess,
      //client
      ClientCanInsert: hasActionAccess(18, 69),
      ClientCanUpdate: hasActionAccess(18, 70),
      ClientCanDelete: hasActionAccess(18, 71),
      ClientCanView: hasActionAccess(18, 72),
      //client-Document
      ClientDocumentCanInsert: hasActionAccess(19, 73),
      ClientDocumentCanUpdate: hasActionAccess(19, 74),
      ClientDocumentCanDelete: hasActionAccess(19, 75),
      ClientDocumentCanView: hasActionAccess(19, 76),
      //client-Invoices
      ClientInvoicesCanInsert: hasActionAccess(20, 77),
      ClientInvoicesCanUpdate: hasActionAccess(20, 78),
      ClientInvoicesCanDelete: hasActionAccess(20, 79),
      ClientInvoicesCanView: hasActionAccess(20, 80),
      //client-Project
      ClientProjectCanInsert: hasActionAccess(21, 81),
      ClientProjectCanUpdate: hasActionAccess(21, 82),
      ClientProjectCanDelete: hasActionAccess(21, 83),
      ClientProjectCanView: hasActionAccess(21, 84),
      //client-MOM
      ClientMOMCanInsert: hasActionAccess(22, 85),
      ClientMOMCanUpdate: hasActionAccess(22, 86),
      ClientMOMCanDelete: hasActionAccess(22, 87),
      ClientMOMCanView: hasActionAccess(22, 88),
      //client-JobRating
      ClientJobRatingCanInsert: hasActionAccess(23, 89),
      ClientJobRatingCanUpdate: hasActionAccess(23, 90),
      ClientJobRatingCanDelete: hasActionAccess(23, 91),
      ClientJobRatingCanView: hasActionAccess(23, 92),
      //Job
      JobCanInsert: hasActionAccess(24, 93),
      JobCanUpdate: hasActionAccess(24, 94),
      JobCanDelete: hasActionAccess(24, 95),
      JobCanView: hasActionAccess(24, 96),
      //Job-Tasksheet
      JobTasksheetCanInsert: hasActionAccess(25, 97),
      JobTasksheetCanUpdate: hasActionAccess(25, 98),
      JobTasksheetCanDelete: hasActionAccess(25, 99),
      JobTasksheetCanView: hasActionAccess(25, 100),
      //Job-JobTimeline
      JobJobTimelineCanInsert: hasActionAccess(26, 101),
      JobJobTimelineCanUpdate: hasActionAccess(26, 102),
      JobJobTimelineCanDelete: hasActionAccess(26, 103),
      JobJobTimelineCanView: hasActionAccess(26, 104),
      //Job- MissingLog
      JobMissingLogCanInsert: hasActionAccess(27, 105),
      JobMissingLogCanUpdate: hasActionAccess(27, 106),
      JobMissingLogCanDelete: hasActionAccess(27, 107),
      JobMissingLogCanView: hasActionAccess(27, 108),
      //Job -Queries
      JobQueriesCanInsert: hasActionAccess(28, 109),
      JobQueriesCanUpdate: hasActionAccess(28, 110),
      JobQueriesCanDelete: hasActionAccess(28, 111),
      JobQueriesCanView: hasActionAccess(28, 112),
      //Job- Drafts
      JobDraftsCanInsert: hasActionAccess(29, 113),
      JobDraftsCanUpdate: hasActionAccess(29, 114),
      JobDraftsCanDelete: hasActionAccess(29, 115),
      JobDraftsCanView: hasActionAccess(29, 116),
      //Job-Documents
      JobDocumentsCanInsert: hasActionAccess(30, 117),
      JobDocumentsCanUpdate: hasActionAccess(30, 118),
      JobDocumentsCanDelete: hasActionAccess(30, 119),
      JobDocumentsCanView: hasActionAccess(30, 120),
      //Job-Reviewer
      JobReviewerCanInsert: hasActionAccess(31, 121),
      JobReviewerCanUpdate: hasActionAccess(31, 122),
      JobReviewerCanDelete: hasActionAccess(31, 123),
      JobReviewerCanView: hasActionAccess(31, 124),
      //User
      UserCanInsert: hasActionAccess(32, 125),
      UserCanUpdate: hasActionAccess(32, 126),
      UserCanDelete: hasActionAccess(32, 127),
      UserCanView: hasActionAccess(32, 128),
      // UserCanInsert: true,
      // UserCanUpdate: true,
      // UserCanDelete: true,
      // UserCanView: true,
      //User -DailyReport
      UserDailyReportCanInsert: hasActionAccess(33, 129),
      UserDailyReportCanUpdate: hasActionAccess(33, 130),
      UserDailyReportCanDelete: hasActionAccess(33, 131),
      UserDailyReportCanView: hasActionAccess(33, 132),
      //User -ViewLog
      UserViewLogCanInsert: hasActionAccess(34, 133),
      UserViewLogCanUpdate: hasActionAccess(34, 134),
      UserViewLogCanDelete: hasActionAccess(34, 135),
      UserViewLogCanView: hasActionAccess(34, 136),
      //User -ManagePortfolio
      UserManagePortfolioCanInsert: hasActionAccess(35, 137),
      UserManagePortfolioCanUpdate: hasActionAccess(35, 138),
      UserManagePortfolioCanDelete: hasActionAccess(35, 139),
      UserManagePortfolioCanView: hasActionAccess(35, 140),
      //User -Manage KRA
      UserManageKRACanInsert: hasActionAccess(36, 141),
      UserManageKRACanUpdate: hasActionAccess(36, 142),
      UserManageKRACanDelete: hasActionAccess(36, 143),
      UserManageKRACanView: hasActionAccess(36, 144),
      // Client Financial Report
      ClientFinancialReportsCanInsert: hasActionAccess(38, 145),
      ClientFinancialReportsCanUpdate: hasActionAccess(38, 146),
      ClientFinancialReportsCanDelete: hasActionAccess(38, 147),
      ClientFinancialReportsCanView: hasActionAccess(38, 152),
      ClientReportsCanView: hasReportDefaultAction(),
      // Client Job Report
      ClientJobReportsCanInsert: hasActionAccess(39, 149),
      ClientJobReportsCanUpdate: hasActionAccess(39, 150),
      ClientJobReportsCanDelete: hasActionAccess(39, 151),
      ClientJobReportsCanView: hasActionAccess(39, 156),

      // Client Task Report
      ClientTaskReportsCanInsert: hasActionAccess(40, 153),
      ClientTaskReportsCanUpdate: hasActionAccess(40, 154),
      ClientTaskReportsCanDelete: hasActionAccess(40, 155),
      ClientTaskReportsCanView: hasActionAccess(40, 160),

      // Client Accountability Report
      ClientAcountabilityReportsCanInsert: hasActionAccess(37, 157),
      ClientAcountabilityReportsCanUpdate: hasActionAccess(37, 158),
      ClientAcountabilityReportsCanDelete: hasActionAccess(37, 159),
      ClientAcountabilityReportsCanView: hasActionAccess(37, 148),

      // Client Attendance Report
      ClientAttendanceReportsCanInsert: hasActionAccess(41, 161),
      ClientAttendanceReportsCanUpdate: hasActionAccess(41, 162),
      ClientAttendanceReportsCanDelete: hasActionAccess(41, 163),
      ClientAttendanceReportsCanView: hasActionAccess(41, 164),

      // Client Team Performance Report
      TeamPerformanceReportsCanInsert: hasActionAccess(42, 165),
      TeamPerformanceReportsCanUpdate: hasActionAccess(42, 166),
      TeamPerformanceReportsCanDelete: hasActionAccess(42, 167),
      TeamPerformanceReportsCanView: hasActionAccess(42, 168),

      // Client KRA Report
      KRAReportsCanInsert: hasActionAccess(43, 169),
      KRAReportsCanUpdate: hasActionAccess(43, 170),
      KRAReportsCanDelete: hasActionAccess(43, 171),
      KRAReportsCanView: hasActionAccess(43, 172),

      //Subscription
      SubscriptionCanInsert: hasActionAccess(44, 173),
      SubscriptionCanUpdate: hasActionAccess(44, 174),
      SubscriptionCanDelete: hasActionAccess(44, 175),
      SubscriptionCanView: hasActionAccess(44, 176),
      //KnowledgeBase
      KnowledgeBaseCanInsert: hasActionAccess(45, 177),
      KnowledgeBaseCanUpdate: hasActionAccess(45, 178),
      KnowledgeBaseCanDelete: hasActionAccess(45, 179),
      KnowledgeBaseCanView: hasActionAccess(45, 180),
      //Leave
      LeaveCanInsert: hasActionAccess(46, 181),
      LeaveCanUpdate: hasActionAccess(46, 182),
      LeaveCanDelete: hasActionAccess(46, 183),
      LeaveCanView: hasActionAccess(46, 184),
      //Visitor
      VisitorCanInsert: hasActionAccess(47, 185),
      VisitorCanUpdate: hasActionAccess(47, 186),
      VisitorCanDelete: hasActionAccess(47, 187),
      VisitorCanView: hasActionAccess(47, 188),
      //Campaign
      CampaignCanInsert: hasActionAccess(48, 189),
      CampaignCanUpdate: hasActionAccess(48, 190),
      CampaignCanDelete: hasActionAccess(48, 191),
      CampaignCanView: hasActionAccess(48, 192),
      //Document Manager
      DocumentManagerCanInsert: hasActionAccess(49, 193),
      DocumentManagerCanUpdate: hasActionAccess(49, 194),
      DocumentManagerCanDelete: hasActionAccess(49, 195),
      DocumentManagerCanView: hasActionAccess(49, 196),
      //Reminder
      ReminderCanInsert: hasActionAccess(50, 197),
      ReminderCanUpdate: hasActionAccess(50, 198),
      ReminderCanDelete: hasActionAccess(50, 199),
      ReminderCanView: hasActionAccess(50, 200),
      //Configure -User Role
      ConfigureUserRoleCanInsert: hasActionAccess(51, 201),
      ConfigureUserRoleCanUpdate: hasActionAccess(51, 202),
      ConfigureUserRoleCanDelete: hasActionAccess(51, 203),
      ConfigureUserRoleCanView: hasActionAccess(51, 204),
      //Configure -Designation
      ConfigureDesignationCanInsert: hasActionAccess(52, 205),
      ConfigureDesignationCanUpdate: hasActionAccess(52, 206),
      ConfigureDesignationCanDelete: hasActionAccess(52, 207),
      ConfigureDesignationCanView: hasActionAccess(52, 208),
      //Status
      ConfigureStatusCanInsert: hasActionAccess(53, 209),
      ConfigureStatusCanUpdate: hasActionAccess(53, 210),
      ConfigureStatusCanDelete: hasActionAccess(53, 211),
      ConfigureStatusCanView: hasActionAccess(53, 212),
      //Services
      ConfigureServicesCanInsert: hasActionAccess(54, 213),
      ConfigureServicesCanUpdate: hasActionAccess(54, 214),
      ConfigureServicesCanDelete: hasActionAccess(54, 215),
      ConfigureServicesCanView: hasActionAccess(54, 216),
      //Client Industry
      ConfigureClientIndustryCanInsert: hasActionAccess(55, 217),
      ConfigureClientIndustryCanUpdate: hasActionAccess(55, 218),
      ConfigureClientIndustryCanDelete: hasActionAccess(55, 219),
      ConfigureClientIndustryCanView: hasActionAccess(55, 220),
      //KRA
      ConfigureKRACanInsert: hasActionAccess(56, 221),
      ConfigureKRACanUpdate: hasActionAccess(56, 222),
      ConfigureKRACanDelete: hasActionAccess(56, 223),
      ConfigureKRACanView: hasActionAccess(56, 224),
      //Check List
      ConfigureCheckListCanInsert: hasActionAccess(57, 225),
      ConfigureCheckListCanUpdate: hasActionAccess(57, 226),
      ConfigureCheckListCanDelete: hasActionAccess(57, 227),
      ConfigureCheckListCanView: hasActionAccess(57, 228),
      //Client Grouping
      ConfigureClientGroupingCanInsert: hasActionAccess(58, 229),
      ConfigureClientGroupingCanUpdate: hasActionAccess(58, 230),
      ConfigureClientGroupingCanDelete: hasActionAccess(58, 231),
      ConfigureClientGroupingCanView: hasActionAccess(58, 332),
      //Leave Type
      ConfigureLeaveTypeCanInsert: hasActionAccess(59, 233),
      ConfigureLeaveTypeCanUpdate: hasActionAccess(59, 234),
      ConfigureLeaveTypeCanDelete: hasActionAccess(59, 235),
      ConfigureLeaveTypeCanView: hasActionAccess(59, 236),
      //Email Templates
      ConfigureEmailTemplatesCanInsert: hasActionAccess(60, 237),
      ConfigureEmailTemplatesCanUpdate: hasActionAccess(60, 238),
      ConfigureEmailTemplatesCanDelete: hasActionAccess(60, 239),
      ConfigureEmailTemplatesCanView: hasActionAccess(60, 240),
      //project Stages
      ConfigureProjectStagesCanInsert: hasActionAccess(61, 241),
      ConfigureProjectStagesCanUpdate: hasActionAccess(61, 242),
      ConfigureProjectStagesCanDelete: hasActionAccess(61, 243),
      ConfigureprojectStagesCanView: hasActionAccess(61, 244),

      ClientProjectStagesCanUpdate: hasActionAccess(63, 250),
      ClientprojectStagesCanView: hasActionAccess(63, 252),

      Config: hasConfigDefaultAction()
    });
  };


  const fetchNotificationCount = async (params) => {
    try {
      const response = await NotificationCount(authDetails.userKeyID);
      if (response.statusCode === 200) {
        setNotificationCount(response.responseData.notificationCount);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const GetUserNotificationListData = async (
    fromDate,
    toDate
  ) => {
    try {
      let response = await GetUserNotificationList({
        // moduleName: PanalModuleName,
        // pageSize: pageSize,
        // pageNo: pageNoList,
        // searchKeyword: searchKeyword,
        userKeyID: authDetails.userKeyID,
        fromDate: fromDate, // Use the passed fromDate or a default
        toDate: toDate, // Use the passed toDate or a default
      });
      if (response.statusCode === 200) {

        const list = response.responseData?.data;
        const unSeenCount = response.responseData?.unSeenCount;
        // setServicesListCount(response.totalCount);
        // setUnSeenCount(unSeenCount);
        setNotificationList(list);
      } else {
      }
    } catch (error) {
      console.log(error);
    }
  };

  const notificationViewData = async (notificationKeyId) => {
    try {
      await NotificationView(notificationKeyId, authDetails.userKeyID);
      await fetchNotificationCount()
      await GetUserNotificationListData()
    } catch (error) {
      console.log(error);
    }
  };


  const formatDateDMY = (dateStr) => {
    if (!dateStr) return "—";

    try {
      return format(
        parse(dateStr, "dd/MM/yyyy hh:mm:ss a", new Date()),
        "dd-MM-yyyy"
      );
    } catch {
      return "—";
    }
  };

  return (
    <AuthContext.Provider
      value={{
        PanalModuleName,
        pageSize,
        unSeenCount,
        validateHours,
        defaultAccess,
        UserAccess,
        GetUserNotificationListData,
        NotificationListCount,
        notificationList,
        setUserAccess,
        validateEmail,
        handlePhoneNumberInput,
        authDetails,
        setLoginItem,
        stringifyNumber,
        fetchNotificationCount,
        notificationCount,
        notificationViewData,
        formatDateDMY
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

const LoaderProvider = ({ children }) => {
  const [loader, setLoader] = useState(false);

  return (
    <LoaderContext.Provider value={{ loader, setLoader }}>
      {children}
      {loader && <Loader />}
    </LoaderContext.Provider>
  );
};

export { LoaderProvider };
export default AuthProvider;
